export default __webpack_public_path__ + "static/media/s1fs4p61.6b12982f.jpg";